module.exports = __webpack_public_path__ + "img/front.832d63ed.jpg";